import { render, staticRenderFns } from "./TalkWithGuideConsent.vue?vue&type=template&id=3c565b09&"
import script from "./TalkWithGuideConsent.vue?vue&type=script&lang=js&"
export * from "./TalkWithGuideConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports